import { ApiService } from "@/modules/api/services/ApiService.ts";
import ApiAxiosInstance from "@/modules/api/services/ApiAxiosInstance.ts";

export default function useApi() {
    return new ApiService(ApiAxiosInstance);
}
